import { render, staticRenderFns } from "./RiskAssessmentFirst.vue?vue&type=template&id=1aedc04a&scoped=true"
import script from "./RiskAssessmentFirst.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentFirst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aedc04a",
  null
  
)

export default component.exports